// extracted by mini-css-extract-plugin
module.exports = {"nav":"StripNav_nav__wO1eY","btn":"StripNav_btn__xTJa0"};